<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three';
export default {
  mixins: [O3DG2],
  data () {
    return {
      controls: false
    }
  },
  mounted () {
    var geometry = new BoxBufferGeometry( 1, 1, 1 );
    geometry.translate( 0, 0.5, 0 );

    for ( var i = 0; i < 500; i ++ ) {
      var material = new MeshBasicMaterial({ wireframe: true, color: 0xffffff * Math.random() })

      var mesh = new Mesh(geometry, material)
      mesh.position.x = Math.random() * 1600 - 800
      mesh.position.y = 0
      mesh.position.z = Math.random() * 1600 - 800
      mesh.scale.x = 20
      mesh.scale.y = Math.random() * 80 + 10
      mesh.scale.z = 20
      mesh.updateMatrix()
      mesh.matrixAutoUpdate = false
      this.ctx.scene.add(mesh)
    }
  }
}
</script>

<style>

</style>